import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable, of, lastValueFrom } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandler } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Respuesta } from '../models';
@Injectable({
  providedIn: 'root'
})
export class HomeService {

  url = environment.api;
  constructor(private http: HttpClient, private errorHandler: ErrorHandler) {}

  obtenerDetalleUsuario( name: number) {
    return this.http.get(`${this.url}Colaborador/${name}`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el detalle del usuario'));
      })
    );
  }

    obtenerDetalleBeneficiarios( name: number) {
    return this.http.get(`${this.url}Colaborador/${name}/beneficiarios`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el detalle del usuario'));
      })
    );
  }

    obtenerListaColaboradores() {
      return this.http.get(`${this.url}Colaborador`)
    .pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener la lista de colaboradores'));
      })
    );
  }

  obtenerDetalleSaldos(idColaborador: number) {
    return this.http.get(`${this.url}Colaborador/${idColaborador}/solicitudes-mensuales`).pipe(
      map((response: any) => {
        if (response.success && response.details) {
          return {
            ...response,
            details: this.transformarResumenSaldos(response.details)
          };
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el detalle de saldos'));
      })
    );
  }

  private transformarResumenSaldos(data: any) {
    const numeroSolicitudes: any = { concepto: 'Número de Solicitudes' };
    const saldoAprobado: any = { concepto: 'Saldo Aprobado' };
    
    data.numeroSolicitudesPorMes?.forEach((item: any) => {
      const mesNombre = item.key.toLowerCase();
      numeroSolicitudes[mesNombre] = item.value;
    });
    
    data.montoAprobadoPorMes?.forEach((item: any) => {
      const mesNombre = item.key.toLowerCase();
      saldoAprobado[mesNombre] = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
      }).format(item.value);
    });
    
    return [numeroSolicitudes, saldoAprobado];
  }

  async getIcon( iconName: string ) {
    return await lastValueFrom(
      this.http.get(`assets/icon/${iconName}`, { responseType: 'text' })
    );
  }

}
